import { AxiosPromise } from "axios";
import { authorizedApi, BaseApi } from "../../shared/api/BaseApi";
import { SearchEmployeesResponseDto } from "./api/SearchEmployeesResponseDto";

export interface SearchService {
    searchEmployees(filterText: string): AxiosPromise<SearchEmployeesResponseDto>;
}

export class DefaultSearchService implements SearchService {
    private searchUrl: string = "/search";

    constructor(private authorizedApi: BaseApi) {}

    searchEmployees(filterText: string): AxiosPromise<SearchEmployeesResponseDto> {
        return this.authorizedApi.get<SearchEmployeesResponseDto>(
            `${this.searchUrl}/SearchEmployees/?searchQuery=${filterText}`,
            {}
        );
    }
}

export class SearchServiceWithResponse implements SearchService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    searchEmployees(filterText: string) {
        return Promise.resolve(this._response);
    }
}

export default new DefaultSearchService(authorizedApi);
